import React from 'react';
import { Button } from './Button';
interface WhatsAppButtonProps {
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'accent' | 'white';
  className?: string;
}
export const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  children = 'Reservar Turno',
  variant = 'primary',
  className = ''
}) => {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <Button href={whatsappUrl} variant={variant} className={className} data-id="element-173">
      {children}
    </Button>;
};